import { render } from "./AnnotationCardReply.vue?vue&type=template&id=82995fc2&scoped=true"
import script from "./AnnotationCardReply.vue?vue&type=script&lang=js"
export * from "./AnnotationCardReply.vue?vue&type=script&lang=js"

import "./AnnotationCardReply.vue?vue&type=style&index=0&id=82995fc2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82995fc2"]])

export default __exports__